import { computeConceptIcon } from '../../core/utils/utils';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import { ProjectConsumer } from '../../core/providers/ProjectProvider';
import SearchDropDown from '../../core/SearchDropDown';
import { globalStyles } from '../../core/style/gstheme';
import { STATUS_REJECTED } from '../../core/utils/constants';

const REJECTED = STATUS_REJECTED;

const styles = Object.assign({}, globalStyles);

class FindConcept extends React.Component {

    render() {

        const { exclude, graph, onSelectConcept, useWorkflow } = this.props;

        return (
            <ProjectConsumer>
                {({ skosXL, defaultLang }) => (
                    <SearchDropDown
                        dataTest="concept-label"
                        focus={true}
                        search={(value, lang) => {
                            return {
                                "search": [
                                    {
                                        "predicate": "http://www.w3.org/2004/02/skos/core#inScheme",
                                        "value": this.props.schemeIRI
                                    },
                                    {
                                        "predicate": "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                                        "value": "http://www.w3.org/2004/02/skos/core#Concept"
                                    },
                                    {
                                        "predicate": [
                                            "http://www.w3.org/2004/02/skos/core#prefLabel"
                                        ],
                                        "value": value,
                                        "isExactMatch": false
                                    }
                                ],
                                "excludeByPath": [
                                    {
                                        "predicate": "http://www.w3.org/2004/02/skos/core#broader",
                                        "target": this.props.source,
                                        "repeat": true
                                    },
                                    {
                                        "predicate": "http://www.w3.org/2004/02/skos/core#narrower",
                                        "target": this.props.source,
                                        "repeat": true
                                    },
                                    {
                                        "predicate": "http://www.w3.org/2004/02/skos/core#related",
                                        "target": this.props.source,
                                        "repeat": true
                                    }
                                ],
                                "graph": [graph],
                                "exclude": exclude,
                                "language": lang,
                                "entailment": skosXL ? ["propertyChain"] : [],
                                "predicates": [
                                    "http://www.w3.org/2004/02/skos/core#prefLabel",
                                    "http://www.w3.org/2002/07/owl#deprecated",
                                    "https://grafsync.graphifi.com/schema/gs/iri",
                                    "https://grafsync.graphifi.com/schema/gs/status",
                                    "http://www.w3.org/2004/02/skos/core#inScheme"
                                ]
                            };
                        }}
                        listSecondIcon={(result) => computeConceptIcon(result, useWorkflow)}
                        listSelectionDisplay={(result, lang) => {
                            if (result.prefLabel && result.prefLabel[lang]) {
                                return Array.isArray(result.prefLabel[lang]) ?
                                    result.prefLabel[lang][0]
                                    :
                                    result.prefLabel[lang];
                            }
                            else return "";
                        }}
                        listDisplay={(result, lang) => {
                            const text = result.prefLabel && result.prefLabel[lang] ?
                                Array.isArray(result.prefLabel[lang]) ?
                                    result.prefLabel[lang].sort().join(" AND ")
                                    :
                                    result.prefLabel[lang]
                                :
                                "No label available";
                            const currentIRI = result.iri ?
                                result.iri[result.iri.length - 1]
                                :
                                result.id;
                            return <div>
                                <Typography variant="body2">
                                    <Tooltip
                                        PopperProps={{
                                            "data-test": "result-tip"
                                        }}
                                        title={currentIRI}>
                                        <span data-test="result-text-words">{text}</span>
                                    </Tooltip>
                                </Typography>
                            </div>;
                        }}
                        sortProp="prefLabel"
                        title="Find a concept"
                        lang={defaultLang}
                        isClickableResult={(result) => !result.invalid && !result.deprecated
                            && !(useWorkflow && result.status && result.status[0] === REJECTED)
                        }
                        chosen={onSelectConcept} />
                )}
            </ProjectConsumer>
        );
    }
}

FindConcept.defaultProps = {
    useWorkflow: false
};

FindConcept.propTypes = {
    source: PropTypes.string.isRequired,
    schemeIRI: PropTypes.string.isRequired,
    graph: PropTypes.string.isRequired,
    exclude: PropTypes.array,
    useWorkflow: PropTypes.bool,
    onSelectConcept: PropTypes.func.isRequired,
    classes: PropTypes.object
};

export default withStyles(styles)(FindConcept);